import React from "react";
import {TopMenuContainer} from "./style";
import Profile from "../../../components/profile";
import Setting from "../../../components/setting";
import Notification from "../../../components/notifications";
import Help from "../../../components/header/components/help";
import Back from "../../../../components/back";
import Logo from "../../../../components/logo";

/**
 * <ul>
 *   <li><Component/></li>
 *   <li><Separator/></li>
 *   <li><Component/></li>
 * </ul>
 */

export const TopBar = props => {
  return (
    <TopMenuContainer shadow={!props.noShadow} borderBottom={!props.noBorder} fluid={!props.noFluid} >
      <div className="inner-container">
        <div className="right-side">
          <ul className="right-side-ul">
            {(props.noBack) ?
              <React.Fragment>
                <Logo/>
              </React.Fragment> :
              <React.Fragment>
                <Back noLabel backTo='/'/>
                <Logo/>
              </React.Fragment>
            }
          </ul>
        </div>
        <div className="left-side">
          <ul className="left-side-ul">
            {props.noProfile ? '' :
              <React.Fragment>
                <li><Help/></li>
                <li><Notification/></li>
                <li><Setting/></li>
                <div className="separator" />
                <li><Profile/></li>
              </React.Fragment>
            }
          </ul>
        </div>
      </div>
    </TopMenuContainer>
  );
};
